import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
    currentUserProfileImageUrl: "",
    currentUserIntialsName: "",
    currentBrandingLogo: "",
    brandingLogo: "",
    getTenantbyDomianNameLogo: "",
};

const userProfileInfo = createSlice({
    name: "userProfileInfo",
    initialState,
    reducers: {
        setUserProfileInfo: (state, action: PayloadAction<string>) => {
            state.currentUserProfileImageUrl = action.payload;
        },
        setUserIntialsName: (state, action: PayloadAction<string>) => {
            state.currentUserIntialsName = action.payload;
        },
        setCurrentBrandingLogo: (state, action: PayloadAction<string>) => {
            state.currentBrandingLogo = action.payload;
        },
        setBrandingLogo: (state, action: PayloadAction<string>) => {
            state.brandingLogo = action.payload;
        },
        setGetTenantbyDomianNameLogo: (state, action: PayloadAction<string>) => {
            state.getTenantbyDomianNameLogo = action.payload;
        }
    }
});

export const { setUserProfileInfo, setUserIntialsName, setCurrentBrandingLogo, setBrandingLogo, setGetTenantbyDomianNameLogo } = userProfileInfo.actions;
export default userProfileInfo.reducer;
